import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { ApprovePlatformClientRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { ApprovePlatformClientResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const approvePlatformClient = (request: ApprovePlatformClientRequest, options?: CashRequestOptions) =>
  post<ApprovePlatformClientRequest, ApprovePlatformClientResponse>('/2.0/cash/approve-platform-client', request, {
    ...options,
    rejectOnError: true,
  })
